import React from "react";
import ProjectContainer from "./Container.jsx";

function ProjectsPage({ title }) {
  return <ProjectContainer title={title} />;
}
export default ProjectsPage;
